module.exports = __webpack_public_path__ + "img/claim.66fae04e.svg";